import { render } from "./ProjectSingleView.vue?vue&type=template&id=9c260fb6"
import script from "./ProjectSingleView.vue?vue&type=script&lang=js"
export * from "./ProjectSingleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__